import {
  interactiveClientObserveUntil,
  interactiveTurnDeadlineAt,
} from "@shared/martinaTurnBudget";

/** Client stopped observing: run may still be alive server-side. */
export const MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED = "MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED";

export const MARTINA_RUN_TERMINAL_STATUSES = ["completed", "failed", "cancelled"] as const;

export type MartinaRunTerminalStatus = (typeof MARTINA_RUN_TERMINAL_STATUSES)[number];

/**
 * Budget of client observation for a durable run. Prefer the turn deadline
 * (+ grace). When reconnecting without a deadline, use a fresh interactive
 * window from now so orphan jobs cannot storm forever.
 */
export function resolveMartinaRunObserveUntil(
  deadlineAt: number | undefined,
  nowMs = Date.now(),
): number {
  if (typeof deadlineAt === "number" && Number.isFinite(deadlineAt) && deadlineAt > 0) {
    return interactiveClientObserveUntil(deadlineAt);
  }
  return interactiveClientObserveUntil(interactiveTurnDeadlineAt(nowMs));
}

export function isMartinaRunTerminalStatus(status: unknown): status is MartinaRunTerminalStatus {
  return typeof status === "string"
    && (MARTINA_RUN_TERMINAL_STATUSES as readonly string[]).includes(status);
}

export function martinaRunObserveBudgetMessage(): string {
  return "Il turno non ha chiuso entro il budget di osservazione. Non so ancora l'esito definitivo: usa Riprova per riconnetterti al run senza duplicare la richiesta.";
}
